module.exports = __webpack_public_path__ + "static/media/LGChemBattery.1de8bd51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LGChemBattery.jpg
// module id = 1028
// module chunks = 0